import { useCallback } from "react";
import { useNotifications } from "@/shared/stores/notificationStore";

export const useSnackbar = () => {
	const addNotification = useNotifications((state) => state.addNotification);

	const showSuccess = useCallback(
		(title: string, message?: string) => {
			addNotification({ type: "success", title, message });
		},
		[addNotification],
	);

	const showError = useCallback(
		(title: string, message?: string) => {
			addNotification({ type: "error", title, message });
		},
		[addNotification],
	);

	const showWarning = useCallback(
		(title: string, message?: string) => {
			addNotification({ type: "warning", title, message });
		},
		[addNotification],
	);

	const showInfo = useCallback(
		(title: string, message?: string) => {
			addNotification({ type: "info", title, message });
		},
		[addNotification],
	);

	return {
		showSuccess,
		showError,
		showWarning,
		showInfo,
		addNotification,
	};
};
